import { useCallback } from "react";
import { useAllFormatOptions } from "./useAllFormatOptions";
import { useParseDateWithFormat } from "./useParseDateWithFormat";

export function useParseDate(): (text: string) => Date | undefined {
  const formatOptions = useAllFormatOptions();
  const parseDateWithFormat = useParseDateWithFormat();

  return useCallback(
    (text) => {
      for (const option of formatOptions) {
        const date = parseDateWithFormat(option, text);

        if (date) {
          return date;
        }
      }

      return undefined;
    },
    [parseDateWithFormat, formatOptions],
  );
}
